import Notifications from '../services/NotificationService'

const plugin = {
    install (Vue, options) {
        Vue.prototype.$notifications = Notifications
    }
}

export default plugin
